module.exports = __webpack_public_path__ + "front/img/i4.645d0626.png";